import { Component, Input } from '@angular/core';
import { CwComponentsModule } from '../../../../shared/components/components.module';
import { DockItem } from '../../models/toolbar.model';

@Component({
  selector: 'zp-toolbar-dock',
  templateUrl: './toolbar-dock.component.html',
  styleUrls: [
    './toolbar-dock.component.scss'
  ],
  imports: [
    CwComponentsModule
  ],
  standalone: true
})
export class ToolbarDockComponent {
  @Input() items: DockItem[] = [];

}
